import { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Table, Grid, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import moment from 'moment';

import { getFacebookFeeds } from '../../../../api_handlers/feeds';

const styles = (theme) => ({
  headerCell: {
    background: '#C4C4C4',
    fontWeight: 600,
    textAlign: 'center',
    fontSize: 12,
  },
  table: {
    minWidth: 650,
  },
  cell: {
    textAlign: 'center',
    fontSize: 12,
  },
});


class PostTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feeds: [],
      count: 0,
      page: 1,
      loading: false,
      openVideoGraph: false,
      selectedVideo: null,
      orderBy: 'created_at',
      order: 'desc',
      columnsArray: [
        "User Name",
        "Likes",
        "Comments",
        "Shares",
        "Views"
      ],
    };
  }

  // async getData() {
  //   this.setState({
  //     loading: true,
  //   });
  //   const resp = await getYoutubeFeeds(this.state.page, {
  //     influencer_id: this.props.selectedInfluencer,
  //     start_date: this.props.startDate ? moment(this.props.startDate).format('YYYY-MM-DD') : null,
  //     end_date: this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : null,
  //     allowedtablecolumns: this.props.allowedTableColumns,
  //     order_by: this.state.order === 'desc' ? '-' + this.state.orderBy : this.state.orderBy,
  //     language_ids:this.props.selectedLanguage
  //   });
  //   this.props.allowedTableColumns.length !== 0 ? this.postColumns() : this.getColumns();
  //   this.getColumns();
  //   this.setState({
  //     feeds: this.state.feeds.concat(resp.results),
  //     count: resp.count,
  //     loading: false,
  //   });
  //   this.props.getFeeds(this.state.feeds)

  // }

  async getData() {
    this.setState({
      loading: true,
    });
    const resp = await getFacebookFeeds({
      influencer_id: this.props.selectedInfluencer,
      start_date: this.props.startDate ? moment(this.props.startDate).format('YYYY-MM-DD') : null,
      end_date: this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : null,
      order_by: this.state.order === 'desc' ? '-' + this.state.orderBy : this.state.orderBy,
    });
    console.log("RESP: ", resp)
    this.setState({
      feeds: this.state.feeds.concat(resp.results),
      count: resp.count,
      loading: false,
    });
    this.props.getFeeds(this.state.feeds)
  }

  async reloadData() {
    await this.setState({
      feeds: [],
      count: 0,
      page: 1,
    });
    this.getData();
    this.props.getFeeds(this.state.feeds)


  }

  componentDidMount() {
    // if (this.props.onRef) this.props.onRef(this);
    // window.addEventListener('scroll', this.infiniteScroll);
    // setTimeout(() => {
    //   this.getData();
    // }, 30);

    if (this.props.onRef) this.props.onRef(this);
    window.addEventListener('scroll', this.infiniteScroll);
    setTimeout(() => {
      this.getData(this.state.page);
    }, 30);

  }

  ellipsis(text) {
    if (text.length > 80) return text.slice(0, 77) + '...';
    return text;
  }

  // infiniteScroll = () => {
  //   if (
  //     window.innerHeight + document.documentElement.scrollTop >=
  //     document.documentElement.offsetHeight
  //   ) {
  //     if (this.state.feeds.length < this.state.count && this.state.loading == false) {
  //       let newPage = this.state.page;
  //       newPage++;
  //       this.setState({
  //         page: newPage,
  //       });
  //       this.getData();
  //     }
  //   }
  // };

  createSortHandler = (property) => async (event) => {
    await this.setState({
      orderBy: property,
      order: this.state.order === 'asc' ? 'desc' : 'asc',
    });
    this.reloadData();
  };

  // async getColumns() {
  //   const colsGet = await getYoutubeFeedsColumns();
  //   this.setState({
  //     columnsArray: colsGet.youtube_columns,
  //   });
  // }

  // async postColumns() {
  //   const colsPost = await postYoutubeFeedsColumns({
  //     youtube_columns: this.props.allowedTableColumns,
  //   });
  //   // console.log(colsPost.youtube_columns)
  // }
  
  render() {
    

    const { classes } = this.props;
    return (
      <>
        <TableContainer component={Paper}>
          <Table stickyHeader className={classes.table} aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell}>Posts</TableCell>

              {this.state.columnsArray.includes("User Name") && (
                <TableCell className={classes.headerCell}>User Name</TableCell>
              )}

              {this.state.columnsArray.includes("Likes") && (
                <TableCell className={classes.headerCell}>Likes</TableCell>
              )}

              {this.state.columnsArray.includes("Comments") && (
                <TableCell className={classes.headerCell}>Comments</TableCell>
              )}

              {this.state.columnsArray.includes("Shares") && (
                <TableCell className={classes.headerCell}>Shares</TableCell>
              )}

              {this.state.columnsArray.includes("Views") && (
                <TableCell className={classes.headerCell}>Views</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.feeds.map((feed) => (
              <TableRow key={feed.id}>
                {/* First column - unchanged */}
                <TableCell component="th" scope="feed" className={classes.cell}>
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item={8}>
                      <Grid
                        container
                        direction="column"
                        justifyContent="space-between"
                        alignItems="flex-start"
                      >
                        <Grid
                          item
                          md={12}
                          style={{
                            wordBreak: 'normal',
                            width: 180,
                            textAlign: 'left',
                          }}
                        >
                          <span>
                            <a
                              href={feed.url}
                              target="_blank"
                              style={{
                                color: '#111111',
                                textDecoration: 'none',
                              }} rel="noreferrer"
                            >
                              {this.ellipsis(feed.caption)}
                            </a>
                          </span>
                        </Grid>
                        <Grid item md={12}>
                          <span>
                            <i>Added on: {feed.added_on}</i>
                          </span>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* {feed.user_name} */}
                </TableCell>

                {/* Posts column - you can update this to whatever field you want */}
                {/* <TableCell className={classes.cell}>{feed.posts || '-'}</TableCell> */}

                {/* User Name */}
                {this.state.columnsArray.includes("User Name") && (
                  <TableCell className={classes.cell}>
                    <a href={'https://www.facebook.com/' + feed.user_name + '/'}>
                      {feed.user_name}
                    </a>
                  </TableCell>
                )}

                {/* Likes */}
                {this.state.columnsArray.includes("Likes") && (
                  <TableCell className={classes.cell}>{feed.like_count}</TableCell>
                )}

                {/* Replys */}
                {this.state.columnsArray.includes("Comments") && (
                  <TableCell className={classes.cell}>{feed.comment_count}</TableCell>
                )}

                {/* Retweets */}
                {this.state.columnsArray.includes("Shares") && (
                  <TableCell className={classes.cell}>{feed.share_count}</TableCell>
                )}

                {/* Views */}
                {this.state.columnsArray.includes("Views") && (
                  <TableCell className={classes.cell}>{feed.video_views}</TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }
}

// export default withStyles(styles, {})(PostTable);

const mapStateToProps = (state) => {
  return {
    // allowedTableColumns: state.brand.displayPanels?.feeds.table_columns,
  };
};

export default connect(mapStateToProps)(withStyles(styles, {})(PostTable));